module.exports = __webpack_public_path__ + "static/media/gram4.d35cc061.jpg";